import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import { finalize } from 'rxjs/operators';

import { FormService } from '@core/services';
import { ErrorModel } from '@core/api';
import { HttpStatusCode } from '@core/enums/http-status-code';

import { RegService } from '../../services/reg.service';
import { RegTokenService, SessionToken } from '../../services/reg-token.service';
import { RegisteredService } from '@core/auth/services/registered.service';

@Component({
  selector: 'auth-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.scss']
})
export class RegistrationComponent implements OnInit {

  regToken: SessionToken = this.regTokenService.value;

  form: FormGroup;
  loading = false;

  hidePassword = true;
  hidePasswordConfirm = true;

  constructor(
    public formBuilder: FormBuilder,
    public formService: FormService,
    private router: Router,
    private regTokenService: RegTokenService,
    private registeredService: RegisteredService,
    private regService: RegService
  ) {
    if (!this.regTokenService.value) {
      this.router.navigate(['/auth/registration']);
    }

    this.regTokenService.localStorage.subscribe(value => {
      this.regToken = value;
    });

    this.buildForm();
  }

  private buildForm() {
    this.form = this.formBuilder.group({
      phone_code: [this.regToken.countryCode],
      phone_number: [this.regToken.phoneNumber],
      last_name: [null, [Validators.required, Validators.maxLength(60)]],
      first_name: [null, [Validators.required, Validators.maxLength(60)]],
      patronymic_name: [null, [Validators.maxLength(60)]],
      email: [null, [Validators.email]],
      password: [null,
        [
          Validators.required,
          Validators.maxLength(16),
          Validators.pattern('(?=^.{8,}$)((?=.*\\d)|(?=.*\\W+))(?![.\\n])(?=.*[A-Z])(?=.*[a-z]).*$'),
        ]
      ],
      confirm: [null,
        [
          Validators.required,
          this.confirmPasswordValidator,
        ]
      ]
    });
  }

  confirmPasswordValidator(control: FormControl) {
    if (typeof(control.parent) !== 'undefined') {
      // @ts-ignore
      const password = control.parent.controls.password;
      return password.value === control.value ? null : { confirmPassword: {} };
    }
  }

  onSubmit() {
    this.loading = true;

    this.formService.markFormGroupTouched(this.form);

    if (this.form.invalid) {
      return this.loading = false;
    }

    this.regService.reg(this.form.value)
      .pipe(finalize(() => this.loading = false))
      .subscribe(() => {
        const guestAuthRedirect = localStorage.getItem('guestAuthRedirect');
        if (guestAuthRedirect) {
          localStorage.removeItem('guestAuthRedirect');
          this.router.navigate(JSON.parse(guestAuthRedirect)).then(() => {
            this.registeredService.save();
            this.regTokenService.reset();
          });
        } else {
          this.router.navigate(['/cabinet']).then(() => {
            this.registeredService.save();
            this.regTokenService.reset();
          });
        }
      }, (error: ErrorModel) => {
        this.formService.serverValidateForm(this.form, error);

        if (error.status === HttpStatusCode.BAD_REQUEST) {
          this.router.navigate(['/auth/registration']).then(() => {
            this.regTokenService.reset();
          });
        }
      });
  }

  changeAccount() {
    this.router.navigate(['/auth/login']).finally(() => {
      this.regTokenService.reset();
    });
  }

  ngOnInit() {
  }

}
